import _ from "lodash";
import {maxLength, minLength, required, requiredIf} from "vuelidate/lib/validators";

export default {
    validations() {
        return {
            templateName: {
                required,
                minLength: minLength(5),
                maxLength: maxLength(355)
            },
            tabs: {
                required,
                $each: {
                    subject: {
                        required: requiredIf(() => {
                            return this.typeInformation[this.selectedType].subject
                        }),
                        minLength: minLength(5),
                        maxLength: maxLength(255)
                    },
                    content: {
                        required: requiredIf(() => {
                            return this.typeInformation[this.selectedType].content
                        }),
                        maxLength: maxLength(this.typeInformation[this.selectedType].contentValidation.maxLength)
                    }
                }
            }
        }
    },
    computed: {
        currentLang() {
            return this.tabs[this.langTabs].value
        },
        availableLangs() {
            return _.map(this.tabs, 'value')
        },
        disabledLogo() {
            return !this.typeInformation[this.selectedType].logo
        },
        disabledAttachment() {
            return !this.typeInformation[this.selectedType].attachment
        },
        disabledSubject() {
            return !this.typeInformation[this.selectedType].subject
        },
        disabledTemplate() {
            return !this.typeInformation[this.selectedType].template
        }
    },
    data() {
        return {
            logoFileOptions: {
                accept: 'image/jpg,image/jpeg,image/png',
                maxSize: '1MB',
                typeError: this.$t('pages.template_builder.logo_options.typeError'),
                sizeError: this.$t('pages.template_builder.logo_options.sizeError'),
                helpText: this.$t('pages.template_builder.logo_options.helpText'),
                acceptText: '(png, jpeg, jpg, only - 1mb max)'
            },
            attachmentFileOptions: {
                accept: 'image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain',
                maxSize: '8MB',
                typeError: this.$t('pages.template_builder.attachment_options.typeError'),
                sizeError: this.$t('pages.template_builder.attachment_options.sizeError'),
                helpText: this.$t('pages.template_builder.attachment_options.helpText'),
                acceptText: '(png, jpg, jpeg, txt, doc, docx, pdf only - 8mb max)'
            },
            typeInformation: {
                confirmCustomizationDetails: {
                    contentValidation: {
                        maxLength: 800,
                        minLength: 1
                    },
                    logo: false,
                    attachment: true,
                    subject: false,
                    template: true,
                    alert: this.$t('pages.template_builder.template_types.confirmCustomizationDetails.alert')
                },
                confirmDeliveryDetails: {
                    contentValidation: {
                        maxLength: 2000,
                        minLength: 1
                    },
                    logo: false,
                    attachment: false,
                    subject: false,
                    template: true,
                    alert: this.$t('pages.template_builder.template_types.confirmDeliveryDetails.alert')
                },
                confirmOrderDetails: {
                    contentValidation: {
                        maxLength: 2000,
                        minLength: 1
                    },
                    logo: false,
                    attachment: false,
                    subject: false,
                    template: true,
                    alert: this.$t('pages.template_builder.template_types.confirmOrderDetails.alert')
                },
                confirmServiceDetails: {
                    contentValidation: {
                        maxLength: 2000,
                        minLength: 1
                    },
                    logo: false,
                    attachment: false,
                    subject: false,
                    template: true,
                    alert: this.$t('pages.template_builder.template_types.confirmServiceDetails.alert')
                },
                warranty: {
                    subjectValidation: {
                        maxLength: 255
                    },
                    contentValidation: {
                        maxLength: 255
                    },
                    logo: false,
                    attachment: true,
                    subject: false,
                    template: false,
                    alert: this.$t('pages.template_builder.template_types.warranty.alert')
                },
                customEmail: {
                    subjectValidation: {
                        maxLength: 255,
                        minLength: 10
                    },
                    contentValidation: {
                        maxLength: 3000,
                        minLength: 10
                    },
                    logo: true,
                    attachment: true,
                    subject: true,
                    template: true,
                    alert: this.$t('pages.template_builder.template_types.customEmail.alert')
                }
            },
            typeOptions: [
                {
                    name: this.$t('pages.template_builder.template_types.confirmCustomizationDetails.title'),
                    value: 'confirmCustomizationDetails',
                },
                {
                    name: this.$t('pages.template_builder.template_types.confirmDeliveryDetails.title'),
                    value: 'confirmDeliveryDetails',
                },
                {
                    name: this.$t('pages.template_builder.template_types.confirmOrderDetails.title'),
                    value: 'confirmOrderDetails',
                },
                {
                    name: this.$t('pages.template_builder.template_types.confirmServiceDetails.title'),
                    value: 'confirmServiceDetails',
                },
                {
                    name: this.$t('pages.template_builder.template_types.warranty.title'),
                    value: 'warranty',
                },
                {
                    name: this.$t('pages.template_builder.template_types.customEmail.title'),
                    value: 'customEmail',
                }
            ],
        }
    }
}